import API from "@/http/http-client";

export const UrlService = {
  async rewriteUrl(params: any): Promise<any> {
    const {data} = await API.post('/dog/rewrite-url', params);
    return data?.url;
  },
};
